<template>
	<div>
		<div class="efficiency-labels">
			<div class="labels-left">
				<div class="efficiency-arrow label-aplusplusplus">A+++</div>
				<div class="efficiency-arrow label-aplusplus">A++</div>
				<div class="efficiency-arrow label-aplus">A+</div>
				<div class="efficiency-arrow label-a">A</div>
				<div class="efficiency-arrow label-b">B</div>
				<div class="efficiency-arrow label-c">C</div>
				<div class="efficiency-arrow label-d">D</div>
				<div class="efficiency-arrow label-e">E</div>
				<div class="efficiency-arrow label-f">F</div>
				<div class="efficiency-arrow label-g">G</div>
			</div>
			<div
				class="label-active active-arrow"
				:class="'label-' + efficiencyLabel"
			>
				{{ efficiency }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetailsCo2Efficiency',
	props: {
		efficiency: {
			type: String,
			default: '',
		},
	},
	computed: {
		efficiencyLabel() {
			if (this.efficiency === 'A+++') {
				return 'aplusplusplus'
			} else if (this.efficiency === 'A++') {
				return 'aplusplus'
			} else if (this.efficiency == 'A+') {
				return 'aplus'
			} else {
				return this.efficiency.toLowerCase()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
$label-height: 20px;
$label-spacing: 8px;
$label-position: ($label-height + $label-spacing);

.efficiency-labels {
	position: relative;
	.labels-left {
		width: 80%;
	}
	.label-active {
		width: 20%;
		position: absolute;
		top: 0;
		right: 0;
		font-size: 14px;
		font-weight: 700;
		padding-left: 5px;
		color: #fff;
		margin-bottom: $label-spacing;
		height: $label-height;
		text-align: center;
		background-color: #000;
		&.label-aplusplusplus {
			top: 0;
		}
		&.label-aplusplus {
			top: $label-position;
		}
		&.label-aplus {
			top: ($label-position * 2);
		}
		&.label-a {
			top: ($label-position * 3);
		}
		&.label-b {
			top: ($label-position * 4);
		}
		&.label-c {
			top: ($label-position * 5);
		}
		&.label-d {
			top: ($label-position * 6);
		}
		&.label-e {
			top: ($label-position * 7);
		}
		&.label-f {
			top: ($label-position * 8);
		}
		&.label-g {
			top: ($label-position * 9);
		}
		&::after {
			content: '';
			position: absolute;
			left: -10px;
			top: 0;
			bottom: 0;
			width: 0;
			height: 0;
			clear: both;
			border-style: solid;
			border-width: 10px 10px 10px 0;
			border-color: transparent #000 transparent transparent;
		}
	}
}

.efficiency-arrow {
	position: relative;
	font-size: 14px;
	font-weight: 700;
	padding-left: 5px;
	color: #fff;
	margin-bottom: $label-spacing;
	height: $label-height;

	&::after {
		content: '';
		position: absolute;
		right: -10px;
		top: 0;
		bottom: 0;
		width: 0;
		height: 0;
		clear: both;
		border-style: solid;
		border-width: 10px 0 10px 10px;
	}
	&.label-aplusplusplus,
	&.label-10 {
		width: 27%;
		background-color: #33a357;

		&::after {
			border-color: transparent transparent transparent #33a357;
		}
	}
	&.label-aplusplus,
	&.label-9 {
		width: 34%;
		background-color: #33a357;

		&::after {
			border-color: transparent transparent transparent #33a357;
		}
	}
	&.label-aplus,
	&.label-8 {
		width: 41%;
		background-color: #79b752;

		&::after {
			border-color: transparent transparent transparent #79b752;
		}
	}

	&.label-a,
	&.label-7 {
		width: 48%;
		background-color: #79b752;

		&::after {
			border-color: transparent transparent transparent #79b752;
		}
	}

	&.label-b,
	&.label-6 {
		background-color: #79b752;
		width: 55%;

		&::after {
			border-color: transparent transparent transparent #79b752;
		}
	}

	&.label-c,
	&.label-5 {
		width: 62%;
		background-color: #fcda17;

		&::after {
			border-color: transparent transparent transparent #fcda17;
		}
	}

	&.label-d,
	&.label-4 {
		width: 69%;
		background-color: #f39200;

		&::after {
			border-color: transparent transparent transparent #f39200;
		}
	}

	&.label-e,
	&.label-3 {
		width: 76%;
		background-color: #be1522;

		&::after {
			border-color: transparent transparent transparent #be1522;
		}
	}

	&.label-f,
	&.label-2 {
		width: 83%;
		background-color: #be1522;

		&::after {
			border-color: transparent transparent transparent #be1522;
		}
	}

	&.label-g,
	&.label-1 {
		width: 90%;
		background-color: #be1522;

		&::after {
			border-color: transparent transparent transparent #be1522;
		}
	}
}
</style>
